

















import {namespace} from 'vuex-class';
import {Component, Vue, Watch} from 'vue-property-decorator';
// import {Client, StoreClient} from '../../store/client/types';
// import {ClientSearchResults, SearchState} from '@/store/search/types';
import {SearchState} from '@/store/search/types';

const stateSearch = namespace('search');
// const clientsState = namespace('client');

@Component
export default class SearchField extends Vue {

    private searchValue: string = '';

    @stateSearch.Action('setQueryAction') private setQuery!: (p: string) => void;
    @stateSearch.State((state) => state) private searchState!: SearchState;


    @Watch('searchValue')
    private searchValueChanged(newValue: string) {
        this.setQuery(newValue);

    }

    @Watch('searchState.query')
    private emptyInput() {


        if (this.searchState.query === '') {
            this.searchValue = '';
        }
    }


}
